module.exports = __webpack_public_path__ + "static/media/nucleo_powered.d5d17258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nucleo_powered.png
// module id = 4073
// module chunks = 0